import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './scss/common.scss'

// Ensure the root element is non-null
const rootElement = document.getElementById('root')

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}
